import { Moment } from 'moment';

import { EditorEligibilityRule } from './editor-eligibility-rule.model';
import moment from 'moment';


export class EditorEligibilityRuleHasDateUserField extends EditorEligibilityRule {
  className = 'HasDateUserField';
  operatorName = 'hasUserField';

  userField: string;
  start: Moment;
  end: Moment;

  constructor(obj?: any) {
    super({
      id: obj?.id ?? null
    });
    this.userField = obj?.userField ?? null;
    this.start = obj?.start ?? null;
    this.end = obj?.end ?? null;
  }

  static getFromSerializedValues(serializedValues: any) {
    return new this({
      userField: serializedValues.userField,
      start: serializedValues.start === null ? null : moment(serializedValues.start),
      end: serializedValues.end === null ? null : moment(serializedValues.end),
    });
  }

  static getEmptyControlConfig(): { [key: string]: any; } {
    return {
      userField: [{ value: null, disabled: true }],
      start: [{ value: null, disabled: true }],
      end: [{ value: null, disabled: true }],
    };
  }

  createCopy(): EditorEligibilityRuleHasDateUserField {
    return new EditorEligibilityRuleHasDateUserField({
      id: this.id,
      userField: this.userField,
      start: this.start,
      end: this.end,
    });
  }

  getUserFieldName(dateUserFieldNames: { id: string, name: string }[]): string {
    if (this.userField === null) { return ''; }
    return dateUserFieldNames
      .find(dateUserFieldName => dateUserFieldName.id === this.userField)?.name ?? $localize `Not valid`;
  }

  getControlsConfig(): { [key: string]: any; } {
    return {
      userField: [this.userField],
      start: [this.start],
      end: [this.end]
    };
  }

  getSerializedValues(): any {
    return {
      userFieldType: 'date',
      userField: this.userField,
      start: this.start ? this.start.format('YYYY-MM-DD') : null,
      end: this.end ? this.end.format('YYYY-MM-DD') : null
    };
  }
}
